import { render, staticRenderFns } from "./WorkRow.vue?vue&type=template&id=6aa05ca3&"
import script from "./WorkRow.vue?vue&type=script&lang=js&"
export * from "./WorkRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports